import { render, staticRenderFns } from "./PurchasesOrderSelector.vue?vue&type=template&id=a38d671c&"
import script from "./PurchasesOrderSelector.vue?vue&type=script&lang=js&"
export * from "./PurchasesOrderSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports